import {v1_PublisherPostStatus_select_column} from '../../generated/types';

const PublisherStatus = {
    ...v1_PublisherPostStatus_select_column,
    res: 'v1_PublisherPostStatus',
    comp: {},
    rel: {},
};

export default PublisherStatus;
